'use es6';

import createBatchedReferenceResolver from '../lib/createBatchedReferenceResolver';
import * as CacheKeys from '../constants/CacheKeys';
import { createFetchByIds, createFetchSearchPage, fetchByIds, fetchSearchPage } from '../api/SiteContentApi';
export const createSiteContentReferenceResolver = options => createBatchedReferenceResolver(Object.assign({
  cacheKey: CacheKeys.SITE_CONTENT,
  createFetchByIds,
  createFetchSearchPage,
  fetchByIds,
  fetchSearchPage
}, options));
export default createSiteContentReferenceResolver();